import { render, staticRenderFns } from "./MainArts.vue?vue&type=template&id=d07e1146&scoped=true&"
import script from "./MainArts.vue?vue&type=script&lang=js&"
export * from "./MainArts.vue?vue&type=script&lang=js&"
import style0 from "./MainArts.vue?vue&type=style&index=0&id=d07e1146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07e1146",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainShowMoreBtn: require('/web/components/MainShowMoreBtn.vue').default})
